import request from '@/utils/request'

export function getStepProfiles(branchId) {
  return request({
    url: `/trace/stepprofiles/userShow/${branchId}`,
    method: 'get'
  })
}

export function userStepProfiles(branchId, data) {
  return request({
    url: `/trace/stepprofiles/user/${branchId}`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/traceStepProfiles.js